import * as React from 'react';
import {
	chakra,
	ImageProps,
	forwardRef,
} from '@chakra-ui/react';
import rewardIcon from 'Assets/svg/rewardIcon.svg';

export const RewardNotificationIcon = forwardRef<ImageProps, 'img'>((props, ref) => {
	return <chakra.img src={rewardIcon} ref={ref} {...props} />;
}); 